import JsonLd from '@/components/JsonLd'
import { webPageSchema, breadcrumbSchema } from '@/lib/jsonLdSchemas'
import Navbar from '@/components/layout/Navbar'
import Footer from '@/components/layout/Footer'
import PageHero from '@/components/sections/PageHero'
import Mission from '@/components/sections/Mission'
import IdealFit from '@/components/sections/IdealFit'
import Team from '@/components/sections/Team'
import Values from '@/components/sections/Values'
import Compare from '@/components/sections/Compare'
import Contact from '@/components/sections/Contact'

export default function About() {
  return (
    <div className="min-h-screen bg-background font-sans text-foreground selection:bg-accent selection:text-white">
      <JsonLd data={webPageSchema({ name: 'About Gigafish', description: "Perth-based digital agency built for challenger brands. Lean, fast, and built to punch above our weight.", path: '/about' })} />
      <JsonLd data={breadcrumbSchema([{ name: 'About', path: '/about' }])} />
      <Navbar light />
      <main>
        <PageHero
          breadcrumb="About"
          titleLines={['End-to-End', 'Digital Partner.']}
          description="We're a Perth-based digital agency built for challenger brands. Lean, fast, and built to punch above our weight — just like you."
          scrollTarget="#mission"
          image=""
          bgImage=""
        />
        <Mission />
        <IdealFit />
        <Team />
        <Values />
        <Compare />
        <Contact />
      </main>
      <Footer />
    </div>
  )
}
